import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../../constants/Config';
import {
  CPM_GET_CARPARK_ACTIVITY_ARRIVALS_LIST,
  CPM_GET_CARPARK_ACTIVITY_DEPARTURES_LIST,
  CPM_GET_CARPARK_ACTIVITY_ENTRIES_LIST,
  CPM_GET_CARPARK_ACTIVITY_EXITS_LIST,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize as deserializeParking } from '../../../models/cpm/parking';
import { deserialize as deserializeAccess } from '../../../models/cpm/access';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkActivity;
const cpmCarparkActivity = (state = initialSettings, action) => {
  switch (action.type) {
    // ARRIVALS
    case CPM_GET_CARPARK_ACTIVITY_ARRIVALS_LIST:
      return {
        ...state,
        arrivals: {
          ...state.arrivals,
          error: null,
          loading: true,
          elements: {
            ...state.arrivals.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_ACTIVITY_ARRIVALS_LIST}_ERROR`:
      return {
        ...state,
        arrivals: {
          ...state.arrivals,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_ACTIVITY_ARRIVALS_LIST}_SUCCESS`:
      return {
        ...state,
        arrivals: {
          ...state.arrivals,
          loading: false,
          elements: {
            ...state.arrivals.elements,
            data: deserializeParking(action.data.listParkings.entries),
            pageNumber: _parseInt(action.data.listParkings.pageNumber),
            pageSize: _parseInt(action.data.listParkings.pageSize),
            totalEntries: _parseInt(action.data.listParkings.totalEntries),
            totalPages: _parseInt(action.data.listParkings.totalPages),
          },
        },
      };
    // DEPARTURES
    case CPM_GET_CARPARK_ACTIVITY_DEPARTURES_LIST:
      return {
        ...state,
        departures: {
          ...state.departures,
          error: null,
          loading: true,
          elements: {
            ...state.departures.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_ACTIVITY_DEPARTURES_LIST}_ERROR`:
      return {
        ...state,
        departures: {
          ...state.departures,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_ACTIVITY_DEPARTURES_LIST}_SUCCESS`:
      return {
        ...state,
        departures: {
          ...state.departures,
          loading: false,
          elements: {
            ...state.departures.elements,
            data: deserializeParking(action.data.listParkings.entries),
            pageNumber: _parseInt(action.data.listParkings.pageNumber),
            pageSize: _parseInt(action.data.listParkings.pageSize),
            totalEntries: _parseInt(action.data.listParkings.totalEntries),
            totalPages: _parseInt(action.data.listParkings.totalPages),
          },
        },
      };
    // ENTRIES
    case CPM_GET_CARPARK_ACTIVITY_ENTRIES_LIST:
      return {
        ...state,
        entries: {
          ...state.entries,
          error: null,
          loading: true,
          elements: {
            ...state.entries.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_ACTIVITY_ENTRIES_LIST}_ERROR`:
      return {
        ...state,
        entries: {
          ...state.entries,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_ACTIVITY_ENTRIES_LIST}_SUCCESS`:
      return {
        ...state,
        entries: {
          ...state.entries,
          loading: false,
          elements: {
            ...state.entries.elements,
            data: deserializeAccess(action.data.listAccesses.entries),
            pageNumber: _parseInt(action.data.listAccesses.pageNumber),
            pageSize: _parseInt(action.data.listAccesses.pageSize),
            totalEntries: _parseInt(action.data.listAccesses.totalEntries),
            totalPages: _parseInt(action.data.listAccesses.totalPages),
          },
        },
      };
    // EXITS
    case CPM_GET_CARPARK_ACTIVITY_EXITS_LIST:
      return {
        ...state,
        exits: {
          ...state.exits,
          error: null,
          loading: true,
          elements: {
            ...state.exits.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_ACTIVITY_EXITS_LIST}_ERROR`:
      return {
        ...state,
        exits: {
          ...state.exits,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_ACTIVITY_EXITS_LIST}_SUCCESS`:
      return {
        ...state,
        exits: {
          ...state.exits,
          loading: false,
          elements: {
            ...state.exits.elements,
            data: deserializeAccess(action.data.listAccesses.entries),
            pageNumber: _parseInt(action.data.listAccesses.pageNumber),
            pageSize: _parseInt(action.data.listAccesses.pageSize),
            totalEntries: _parseInt(action.data.listAccesses.totalEntries),
            totalPages: _parseInt(action.data.listAccesses.totalPages),
          },
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkActivity;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkActivity.js